import React, { useState, useEffect } from 'react';
import { Grid, Icon, IconButton, makeStyles, Typography } from '@material-ui/core';
import { blueGrey, green } from '@material-ui/core/colors';
import InputForm from '../../../components/Forms/InputForm';
import DisplayError from '../../../components/DisplayError';
import RoundedButton from '../../../components/Actions/RoundedButton';


const Congratulations = (props) => {

    const classes = useStyles()
    const {system, form, actions, onClose} = props

    return ( 
        <div>
            <Grid container alignItems='center'>
                <Grid item xs>
                    <Typography  variant='h5' style={{fontWeight:600,}}>Congratulations!</Typography>
                </Grid>
            </Grid>
            <div style={{marginTop:16}}>
                <div style={{padding:'24px 0px'}}>
                    <Grid container spacing={3} justify='center' alignItems='center' direction='column'>
                        <Grid item>
                            <Typography>Your password has been updated sucessfully.</Typography>
                        </Grid>
                        <Grid item>
                            <div className={classes.iconContainer}>
                                <div className={classes.icon}><Icon color='inherit' style={{
                                fontSize:48, marginTop:8}}>done</Icon></div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div style={{marginTop:32, textAlign:'center'}}>
                    <DisplayError>{system.error}</DisplayError>
                    <RoundedButton loading={system.loading} onClick={onClose}>Log in</RoundedButton>
                </div>
            </div>
            
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    iconContainer:{
        width:80, height:80,
        borderRadius:'50%',
        border:`1px solid ${green[700]}`,
        position:'relative'
    },
    icon:{
        color:green[700],
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)'
    }
}))
 
export default Congratulations;